<div class="checkout-payment-item"
     mat-ripple
     matRippleColor="#efefef25"
     [class.attenuated-accent-primary-btn]="checked"
     [class.accent-border-color]="checked && !inExpressMode"
     (click)="onClick()">
  <div class="checkout-payment-item-lateral">
      <span class="material-symbols-rounded primary-icon me-3" [class.accent-color]="checked">
          {{ checked ? 'radio_button_checked' : 'radio_button_unchecked' }}
      </span>
    <img src="../../../../assets/img/{{ payment.brand }}_96.png"
      class="checkout-payment-item-icon"
      width="36"
      height="36"
      alt="Payment item icon">
    <div class="payment-item-text-container">
        <p class="medium-text">
            {{ payment.brand | titlecase }}
<!--            {{ payment.card_type === 'credit' ? 'Credito': 'Debito' }}-->
            <strong> {{ payment.last4 }}</strong>
        </p>
        <p class="small-label">Exp:
            <strong>{{ payment.exp_month }} / {{ payment.exp_year }}</strong>
        </p>
    </div>
<!--    <span class="material-symbols-rounded primary-icon me-3">-->
<!--        {{ checked ? 'radio_button_checked' : 'radio_button_unchecked' }}-->
<!--    </span>-->
  </div>
  <button mat-icon-button
    [hidden]="inExpressMode"
    (click)="onDelete()"
    class="bg-transparent">
      <span class="text-danger material-symbols-rounded">delete</span>
  </button>
</div>

<mat-divider *ngIf="showDivider"></mat-divider>

<ng-template #deletePaymentModal>
    <div class="delete-payment-container">
        <div class="delete-payment-header">
            <img src="../../../assets/img/{{ payment.brand }}_96.png"
                 class="checkout-payment-item-icon"
                 width="64"
                 height="64"
                 alt>
        </div>
        <div class="delete-payment-content">
            <div class="delete-payment-text-area">
                <h5 class="app-module-title">
                    <strong>Eliminar forma de pago</strong>
                </h5>
                <p class="small-label">
                    Se removera la tarjeta de pago con terminación **** {{ payment.last4 }} de la cuenta.
                    <strong> ¿Desea continuar?</strong>
                </p>
            </div>
        </div>
        <div class="delete-payment-bottom multiple-separation-bottom-actions">
            <button mat-flat-button
                    class="attenuated-accent-red-btn"
                    (click)="proceedToDelete(payment)">
                <span class="material-symbols-rounded">delete</span>
                <strong>Eliminar</strong>
            </button>
            <button mat-flat-button
                    class="small-text payment-delete-cancel-btn"
                    (click)="dismissDeletion()">
                <span class="material-symbols-rounded">close</span>
                <strong>Cancelar</strong>
            </button>
        </div>
    </div>
</ng-template>
